import { render, staticRenderFns } from "./SimplePage.vue?vue&type=template&id=a5608cfc&"
import script from "./SimplePage.vue?vue&type=script&lang=js&"
export * from "./SimplePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports